import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from './user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { RestComponent } from './lib/RestComponent';
import { NotificationService } from './notification.service';
import UIkit from './lib/uikit';

@Component({
  selector: 'sign-up',
  templateUrl: '../templates/signup.component.html',
  styleUrls: ['../styles/components/signup.component.less']
})
export class SignUpComponent extends RestComponent implements OnInit, OnDestroy, AfterViewInit {
  privateStatus: boolean = true;
  name: string;
  email: string;
  password: string;
  orgName: string;
  legalAddress: string;
  checkingAccount: string;
  inn: string;
  kpp: string;

  from: string = '/';
  modalUI: any;
  @ViewChild('modal', { static: false }) modalRef: ElementRef;

  constructor(
    private userService: UserService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super();
  }

  public ngOnInit() {
    this.subscription = this.route.queryParams.subscribe((params) => {
      if (params['from']) this.from = decodeURIComponent(params['from']);
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public ngAfterViewInit() {
    if (typeof window === 'undefined') return;

    const modal = <HTMLElement>this.modalRef.nativeElement;
    this.modalUI = UIkit.modal(modal, { bgClose: false });
    this.modalUI.show();
    const initUrl = this.router.url;
    modal.addEventListener('hide', () => {
      if (this.router.url === initUrl) {
        this.router.navigate([{outlets: {modal: null}}]);
      }
    });
  }

  public onstatusChange(status: boolean) {
    this.privateStatus = status;
  }

  public async submit(e: Event, formNg: NgForm) {
    if (formNg.invalid) {
      return this.notificationService.show({
        message: 'Некорректно заполнены поля',
        status: 'danger'
      });
    }

    this.loadingState = true;
    const form = <HTMLFormElement>e.target;

    const data: any = {name: {}};
    const nameArray = this.name.split(' ');
    data.name.first = nameArray[0];
    data.name.last = (nameArray.length > 1) ? nameArray[1] : '';
    data.email = this.email;
    data.password = this.password;
    data.clientType = 'individual';

    if (!this.privateStatus) {
      data.orgName = this.orgName;
      data.legalAddress = this.legalAddress;
      data.checkingAccount = this.checkingAccount;
      data.inn = this.inn;
      data.kpp = this.kpp;
    }

    try {
      await this.userService.signUp(data);
      await this.userService.signIn({LOGIN: data.email, PASSWORD: data.password});
      form.reset();
      this.error = false;
      this.resultMessage = 'Регистрация успешна';
      this.modalUI.hide();
      if (this.from) this.router.navigate([this.from, {outlets: {modal: null}}]);
    } catch (e) {
      this.error = true;
      this.errorMessage = e.message;
    } finally {
      this.loadingState = false;
    }
  }
}
